var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "registerForm", method: "post" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.validateBeforeSubmit($event)
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col", staticStyle: { padding: "10px" } },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("login.enter_name"))),
            ]),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.registerData.name.$error,
                type: "text",
                placeholder: _vm.$t("login.enter_name"),
                name: "name",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.registerData.name.$touch()
                },
              },
              model: {
                value: _vm.registerData.name,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.registerData,
                    "name",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "registerData.name",
              },
            }),
            _vm._v(" "),
            _vm.$v.registerData.name.$error
              ? _c("div", [
                  !_vm.$v.registerData.name.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.$tc("validation.required"))),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col", staticStyle: { padding: "10px" } },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("login.enter_company"))),
            ]),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.registerData.company.$error,
                placeholder: _vm.$t("login.enter_company"),
                type: "text",
                name: "company",
              },
              on: {
                input: function ($event) {
                  return _vm.$v.registerData.company.$touch()
                },
              },
              model: {
                value: _vm.registerData.company,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.registerData,
                    "company",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "registerData.company",
              },
            }),
            _vm._v(" "),
            _vm.$v.registerData.company.$error
              ? _c("div", [
                  !_vm.$v.registerData.company.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.$tc("validation.required"))),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col", staticStyle: { padding: "10px" } },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("login.enter_website"))),
            ]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                placeholder: _vm.$t("login.enter_website"),
                type: "text",
                name: "website",
              },
              model: {
                value: _vm.registerData.website,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.registerData,
                    "website",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "registerData.website",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col", staticStyle: { padding: "10px" } },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("login.enter_phone"))),
            ]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                placeholder: _vm.$t("login.enter_phone"),
                type: "text",
                name: "phone",
              },
              model: {
                value: _vm.registerData.phone,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.registerData,
                    "phone",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "registerData.phone",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { padding: "10px" } },
        [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("login.enter_email"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
          _vm._v(" "),
          _c("base-input", {
            attrs: {
              invalid: _vm.$v.registerData.email.$error,
              placeholder: _vm.$t("login.enter_email"),
              type: "email",
              name: "email",
            },
            on: {
              input: function ($event) {
                return _vm.$v.registerData.email.$touch()
              },
            },
            model: {
              value: _vm.registerData.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.registerData,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "registerData.email",
            },
          }),
          _vm._v(" "),
          _vm.$v.registerData.email.$error
            ? _c("div", [
                !_vm.$v.registerData.email.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$tc("validation.required"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.registerData.email.email
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$tc("validation.email_incorrect"))),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { padding: "10px" } },
        [
          _c("p", { staticClass: "input-label" }, [
            _vm._v(_vm._s(_vm.$t("login.enter_password")) + " "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
          ]),
          _vm._v(" "),
          _c("base-input", {
            attrs: {
              invalid: _vm.$v.registerData.password.$error,
              type: "password",
              placeholder: _vm.$t("login.enter_password"),
              "show-password": "",
            },
            on: {
              input: function ($event) {
                return _vm.$v.registerData.password.$touch()
              },
            },
            model: {
              value: _vm.registerData.password,
              callback: function ($$v) {
                _vm.$set(_vm.registerData, "password", $$v)
              },
              expression: "registerData.password",
            },
          }),
          _vm._v(" "),
          _vm.$v.registerData.password.$error
            ? _c("div", [
                !_vm.$v.registerData.password.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$tc("validation.required"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.registerData.password.minLength
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tc(
                              "validation.password_min_length",
                              _vm.$v.registerData.password.$params.minLength
                                .min,
                              {
                                count:
                                  _vm.$v.registerData.password.$params.minLength
                                    .min,
                              }
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { padding: "10px" } },
        [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("wizard.confirm_password"))),
          ]),
          _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
          _vm._v(" "),
          _c("base-input", {
            attrs: {
              invalid: _vm.$v.registerData.confirm_password.$error,
              type: "password",
              placeholder: _vm.$t("wizard.confirm_password"),
              name: "confirm_password",
            },
            on: {
              input: function ($event) {
                return _vm.$v.registerData.confirm_password.$touch()
              },
            },
            model: {
              value: _vm.registerData.confirm_password,
              callback: function ($$v) {
                _vm.$set(
                  _vm.registerData,
                  "confirm_password",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "registerData.confirm_password",
            },
          }),
          _vm._v(" "),
          _vm.$v.registerData.confirm_password.$error
            ? _c("div", [
                !_vm.$v.registerData.confirm_password.sameAsPassword
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.$tc("validation.password_incorrect"))),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-button",
        {
          staticClass: "btn btn-login btn-full",
          attrs: { loading: _vm.isLoading, type: "submit" },
        },
        [_vm._v(_vm._s(_vm.$t("login.register")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "other-actions mb-4" },
        [
          _c("router-link", { attrs: { to: "/login" } }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("general.back_to_login")) + "\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }